
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as pingHfxcznLCai29zNo6JIPMBS1xqSed2KVWMPAwU5_45F_a4Meta } from "/vercel/path1/pages/ping.vue?macro=true";
import { default as indexqYfu2AWB8IxcjYRpy3wfXaf7X1a5C3aGnOp5CZNI1c4Meta } from "/vercel/path1/pages/index.vue?macro=true";
import { default as authenticateMKbQ2cBFni_kjeHfjMr8b8jpUROOaiS_45KsK6k5xA2lEMeta } from "/vercel/path1/pages/authenticate.vue?macro=true";
import { default as unauthenticateME6_onzj75GmVACpVowE38uJXsIL_BlbXuXD9td91qEMeta } from "/vercel/path1/pages/unauthenticate.vue?macro=true";
import { default as indexR3NND4_45x_45M4z31teDYpUW6EnRqMqqxjBrv13bpwDpJIMeta } from "/vercel/path1/pages/auto/[policyNumber]/index/index.vue?macro=true";
import { default as notesmnbAsMcV2GaLKx5t12s4J6Lw3Hkl0oHmISOx_45BbQK30Meta } from "/vercel/path1/pages/auto/[policyNumber]/index/notes.vue?macro=true";
import { default as claimsdcU_45oDgO34W2ulNjrDl3usQ4njuIsiJFsV84EJkDVSMMeta } from "/vercel/path1/pages/auto/[policyNumber]/index/claims.vue?macro=true";
import { default as policyo5_PVD6SIAl7cBH_JJRJomC_h1GVgwEapaaYb5q96vMMeta } from "/vercel/path1/pages/auto/[policyNumber]/index/policy.vue?macro=true";
import { default as billingCwbeHtEu6VVY7SyeOLWqYCw_45fViG2lj7hoDch0b0U2sMeta } from "/vercel/path1/pages/auto/[policyNumber]/index/billing.vue?macro=true";
import { default as partiesJnaMLxXaK2GGJpDnBbu9K1Kta1cls6FfEo0RuW9mQHwMeta } from "/vercel/path1/pages/auto/[policyNumber]/index/parties.vue?macro=true";
import { default as activity1Ayw8YD1ZQPhjfUSa_IWNZvysDxGr6PA37LJYXXv49AMeta } from "/vercel/path1/pages/auto/[policyNumber]/index/activity.vue?macro=true";
import { default as documentsTI5INtlgp56ELi0TmAQZgVHBGpk9_45PqoLE4_45n2PtP6oMeta } from "/vercel/path1/pages/auto/[policyNumber]/index/documents.vue?macro=true";
import { default as indexOacNblXxLXD43UYcSSyd7TytpBC7dbi_7DDTxTRVmoIMeta } from "/vercel/path1/pages/auto/[policyNumber]/index.vue?macro=true";
import { default as admin7u7cp95gCJwYynkuBQ8hpJfl2G40dl71iB_45VFr5mi5gMeta } from "/vercel/path1/pages/auto/[policyNumber]/change/[id]/admin.vue?macro=true";
import { default as billingR4X2VlCgThtfOpTeJT8flSRrlMA_45Onm1UiRHL09m_0IMeta } from "/vercel/path1/pages/auto/[policyNumber]/change/[id]/billing.vue?macro=true";
import { default as driversK_457o_45lB253uBI3muITXwXlvxgVOrPUkMKxU2R6_45pLX0Meta } from "/vercel/path1/pages/auto/[policyNumber]/change/[id]/drivers.vue?macro=true";
import { default as partiess0syHRr4yPI1vni7Rc_wnAJCotChcWuDSBacjj_qk28Meta } from "/vercel/path1/pages/auto/[policyNumber]/change/[id]/parties.vue?macro=true";
import { default as coverageTl1ZNx_crzPICW4QohS8_45_45klkXAbalqzG9Jg5DCUarIMeta } from "/vercel/path1/pages/auto/[policyNumber]/change/[id]/coverage.vue?macro=true";
import { default as vehiclesutOfz6aAJM8c3exY9JP5QmYVe7FT5UHeE4VE66wZ2MwMeta } from "/vercel/path1/pages/auto/[policyNumber]/change/[id]/vehicles.vue?macro=true";
import { default as householdCa5aV1NWrjLuKouzLiPkkh_D_VgFHi7wRnvKSYjXETcMeta } from "/vercel/path1/pages/auto/[policyNumber]/change/[id]/household.vue?macro=true";
import { default as review_45and_45bindYTLjLD4OWWQjwCiGy_xf_45U9nDmPre6DrvI_CnovUt_UMeta } from "/vercel/path1/pages/auto/[policyNumber]/change/[id]/review-and-bind.vue?macro=true";
import { default as changeGjdBfPGcB4HKuy7zEVagV18mZ65VAPyr9eU7pq6WeQwMeta } from "/vercel/path1/pages/auto/[policyNumber]/change.vue?macro=true";
import { default as queriesUF3fcMygbt_7fKAwxzCIVDs9xLrKIJStHvAARpRdAP8Meta } from "/vercel/path1/pages/auto/[policyNumber]/queries.js?macro=true";
import { default as mutationsEcuYFeyBwaM8L1_45ECGJwpk3O6Ltg_45KNUPlEXVAwia7MMeta } from "/vercel/path1/pages/auto/[policyNumber]/mutations.js?macro=true";
import { default as _91policyNumber_93DT4ejZcwRlSy3mdO29HORR6A7849mfQyxjZ0H8s8xwsMeta } from "/vercel/path1/pages/auto/[policyNumber].vue?macro=true";
import { default as index7H51HEF5ROB7v1AvSQqaISG7AWYaLx1AYZDfB3Hjl8IMeta } from "/vercel/path1/pages/home/[policyNumber]/index/index.vue?macro=true";
import { default as notes6zTTGsbYfuEej_45f4Bt5lugp_uW86POkehf3L_eVVPgYMeta } from "/vercel/path1/pages/home/[policyNumber]/index/notes.vue?macro=true";
import { default as claims9Od20x9ewo_sClX3WAyIY6Tuxae9UsOF_RVnde_45mL_IMeta } from "/vercel/path1/pages/home/[policyNumber]/index/claims.vue?macro=true";
import { default as queriestri2WqrLiw25VGlDViNUYNg5ivsAKyO96h28F01XlzYMeta } from "/vercel/path1/pages/home/[policyNumber]/index/queries.js?macro=true";
import { default as billingL11kdTnq5D79AvH2mL0CqTma4EMou8Nnj_45FfqBaca4MMeta } from "/vercel/path1/pages/home/[policyNumber]/index/billing.vue?macro=true";
import { default as partiesz2MvaU8JbjqXdsPe6UbqQU9_45msU_QX7buyO08YbeGg4Meta } from "/vercel/path1/pages/home/[policyNumber]/index/parties.vue?macro=true";
import { default as activity56w2v1ZaZAo_d2w_458i_45UhxAFgSp0C5_45aMTZEB7_fWX8Meta } from "/vercel/path1/pages/home/[policyNumber]/index/activity.vue?macro=true";
import { default as mutationsxUyBrHGbIbmPQ75jjOYQWU8djmWGalDn27_45j2CopqggMeta } from "/vercel/path1/pages/home/[policyNumber]/index/mutations.js?macro=true";
import { default as documentsp3UBWJUnXRpM_tkKmAYMgcrbIBjBjAbcunMf_siCjfAMeta } from "/vercel/path1/pages/home/[policyNumber]/index/documents.vue?macro=true";
import { default as policy_45details6swQXnXmaooopUKa2dLUxRH20IdlWO24tDbSPL_45ThsMMeta } from "/vercel/path1/pages/home/[policyNumber]/index/policy-details.vue?macro=true";
import { default as renewal_45comparisonCkszRH3WK6nyiffWc4JYqGdZ2NK4rFmVKibXDiozvc0Meta } from "/vercel/path1/pages/home/[policyNumber]/index/renewal-comparison.vue?macro=true";
import { default as index_2xEf9HXpWFE5IbsVkWAyQsrjVAcPZAiNMHsJl0REj0Meta } from "/vercel/path1/pages/home/[policyNumber]/index.vue?macro=true";
import { default as queriesfVW7xc4eR2XgYjHw16uUdLfCpMU5y75GFFiZYUOXUowMeta } from "/vercel/path1/pages/home/[policyNumber]/queries.js?macro=true";
import { default as damage4neR7NJG0PCyCj_89KyuEOD_45_s41N9GWdCq9a4wgzzUMeta } from "/vercel/path1/pages/home/[policyNumber]/file-claim/damage.vue?macro=true";
import { default as reviewYc787jEJcvyPX5AbJZ4ZbldwgkwIRpQlfkzEVjyUuhkMeta } from "/vercel/path1/pages/home/[policyNumber]/file-claim/review.vue?macro=true";
import { default as contactssYGvD23b_zqqx2CIMei__LtEvNxBaZOb8miM_HH9_ksMeta } from "/vercel/path1/pages/home/[policyNumber]/file-claim/contacts.vue?macro=true";
import { default as createClaimPayloadticAZR62wxtP_3GFAVf_H0zgAYo_Oq3PiQv8is_45r_45ooMeta } from "/vercel/path1/pages/home/[policyNumber]/file-claim/createClaimPayload.js?macro=true";
import { default as file_45claimvu5uaVFAtqt8sDABBpEELU_4548gdoXLREhtXhMWZGJU4Meta } from "/vercel/path1/pages/home/[policyNumber]/file-claim.vue?macro=true";
import { default as adminPbBolq8bOS2814U1FJSh28te5dJ2d0_45fCaBDkRmYKigMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/change/admin.vue?macro=true";
import { default as queriessqD_45HhgvGrFx5MNaRwpHQ1C6ZHz1DwLnEYeqdjsvAlYMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/change/queries.js?macro=true";
import { default as reviewtrzB0eQHEFkBl_45GGrEDLOUImlsw4u6MA_iyDT7CmPXsMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/change/review.vue?macro=true";
import { default as billingJYNP3jwIwlB2sY42nkLPyGm23ObS6n1m_45rF0cNhfj0IMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/change/billing.vue?macro=true";
import { default as partiesKMPcyhibCbytw6KF5C6T_451oAkvpmuVPttmzcH55wCRYMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/change/parties.vue?macro=true";
import { default as coverageHyf7Yy15IaORoyNRN3yJodZEd7lXuKD3LMpP_VtKEsQMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/change/coverage.vue?macro=true";
import { default as mutationss95_45preUDPPoVwxsOgHtaZRzGUUKR5v2PjjQM8FKmAUMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/change/mutations.js?macro=true";
import { default as propertyCg1PA8Xe_45_NH7Simqytbln_45B70rjvm68_45PpM_45FFg__QMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/change/property.vue?macro=true";
import { default as partiesStateFactoryHMMnwxsAAnVXyFj_sImusMJeq1BFC94buiRyV__P0KwMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/change/partiesStateFactory.js?macro=true";
import { default as change7182CZoNzXAZewB4_45eyMKprvBKsXCIsrd5y59qYfwgEMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/change.vue?macro=true";
import { default as queriesI3_45fFsEE2H_45rvFXQ77TxvbSvrRpBnRLSVfENPdkuJpEMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/queries.js?macro=true";
import { default as mutationsP3qgzuZQymX8Q8KtN1H4IX4_PW8IQgB79wSIVg7Ow08Meta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/mutations.js?macro=true";
import { default as queries2ekQU9s_45S_ftGwEilI231jFVa_45qtifeZFJvXtBzRPWcMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/reschedule/queries.js?macro=true";
import { default as reviewela_45I_DguLBdVF_J96YVe5NjLq3E38yWhpGIrzpP7rQMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/reschedule/review.vue?macro=true";
import { default as mutationsc23OSDhBC8QSKdnAZMLhrd5Om70_BMuguyL3mNWphmAMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/reschedule/mutations.js?macro=true";
import { default as effectiveDateZTcEzk9jNF1GEbGPVYK_XTMCWqlvPgm_FlkUNE_jg_cMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/reschedule/effectiveDate.vue?macro=true";
import { default as reschedule06CoVOR79MhpeNzcmjIDAp4_45mhLDbL7GGwpV6EG_451aQMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/reschedule.vue?macro=true";
import { default as indexq08lMWbbh05mbCa4HR_A8P7NgAPJSvj_45387eBTfCsgcMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/cancellation/index.vue?macro=true";
import { default as review9UkPz_mWUIUg4okUkzEi6lKUFFBJGn6kaR6achvBWN8Meta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/cancellation/review.vue?macro=true";
import { default as cancellationContextgD187b2OFs_45YMkkRr6Oiv5gGwcU6jbluzZO001MZJKMMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/cancellation/cancellationContext.js?macro=true";
import { default as cancellation211n01_45yrFXxoEkGRKCZQbHOQCYXNHLIC6KNHm8TsPQMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/cancellation.vue?macro=true";
import { default as querieshOvMVYltE1F_eXPCbcSE5hS8F40dSxnV_45mC5z7n6d9MMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/agentOfRecord/queries.js?macro=true";
import { default as review2izdKL0iRj74xfYWQ1R2YON97fQnLtTsPd392EKQ_45T8Meta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/agentOfRecord/review.vue?macro=true";
import { default as update4KNSSKeKmbkJ9JGyVZsfxzuzWlUvRd_vscEc_45gOSUUQMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/agentOfRecord/update.vue?macro=true";
import { default as mutationsXDYkwc7laJZOi1IathPVXsVTCOae14GuD6834Y327TcMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/agentOfRecord/mutations.js?macro=true";
import { default as agentOfRecordMdHVkYmy5GHwiU3y0a6t1lk9OOHq9PIntmX3hVL3_45xsMeta } from "/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/agentOfRecord.vue?macro=true";
import { default as _91policyNumber_932Nxjd1DB7VNDPo5XI_45A2UyMPgYYauY7Yot_45QR8LxBFQMeta } from "/vercel/path1/pages/home/[policyNumber].vue?macro=true";
import { default as indexTXD2rJTDeIDp9A6H1WuJi5cRwAx9pkI_45yRJtYT5aTB0Meta } from "/vercel/path1/pages/account/search/index.vue?macro=true";
import { default as indexGsQSYwypq6dYimlaTBeXIgEgr83UhxufpuuaSm27SUAMeta } from "/vercel/path1/pages/admin/settings/index/team/index.vue?macro=true";
import { default as _91userID_936KhDTgzITREuo_45bpQ3WiqS62eBu_dOw1ssoiJmosUqEMeta } from "/vercel/path1/pages/admin/settings/index/team/[userID].vue?macro=true";
import { default as teamwIbTOC1is2t5bsi_ZumQKGs2TvA5XQ5abneOWl9vJD8Meta } from "/vercel/path1/pages/admin/settings/index/team.vue?macro=true";
import { default as indexEBFIXigkemHGKI0uLCaoK5jNKnDRXfyxlzK14peuiEMMeta } from "/vercel/path1/pages/admin/settings/index/index.vue?macro=true";
import { default as querieso6exlBj7eWKZ0wQcqKJFv3Tbrqc6CrK95cgEvou7X_45AMeta } from "/vercel/path1/pages/admin/settings/index/queries.js?macro=true";
import { default as mutationsNvJH3_mWXTYtYN7l0k4t4fivRmaSuKlxJUpXn7MPdjAMeta } from "/vercel/path1/pages/admin/settings/index/mutations.js?macro=true";
import { default as commissionsgqIK5G42ZnmrMPR_457a4iQXwficRAGOuA3VsWBRPcrPkMeta } from "/vercel/path1/pages/admin/settings/index/commissions.vue?macro=true";
import { default as integrations4_XgLkggoote5PNa3Hw55Yl6YPHPCg82AqCIdKaMGoQMeta } from "/vercel/path1/pages/admin/settings/index/integrations.vue?macro=true";
import { default as agency_45details5By_45xQwDNaGMyhFNxlmM2U_459VSXlmrK7IqKWi_45aLPVYMeta } from "/vercel/path1/pages/admin/settings/index/agency-details.vue?macro=true";
import { default as indexElOgL68gsBNUUTPeRNoRdudcYO4400M0E3SuSRFmLqAMeta } from "/vercel/path1/pages/admin/settings/index.vue?macro=true";
import { default as queriesjJFunxVdLayF8rrF9oLwUO_45Hj4QEUi2TdcPvaSSHsQsMeta } from "/vercel/path1/pages/account/search/queries.js?macro=true";
import { default as indexRlt32t_454LZ38NJrvLupCH_45k4WNjz_456ZFXfwIFogbQ_wMeta } from "/vercel/path1/pages/dashboards/search/index.vue?macro=true";
import { default as queriesAFVnU3r13sONwM3oIXhnxNBJ2GIiDSZZrQyvQ8XYAZAMeta } from "/vercel/path1/pages/dashboards/search/queries.js?macro=true";
import { default as indexHNvyT6WglBoNhKekP_KUVMpo9eaA8t_45sFe9KogOJBuYMeta } from "/vercel/path1/pages/account/[accountID]/index.vue?macro=true";
import { default as indexmhHxUnyynFMJP6RGA_45ozciGRdu_45WdL8G5BkfYDzhmycMeta } from "/vercel/path1/pages/admin/policy-search/index.vue?macro=true";
import { default as queriesqxGZjH83gj619uya26MMVP_45_ZDAy0ZHSnaGU4krCZuwMeta } from "/vercel/path1/pages/account/[accountID]/queries.js?macro=true";
import { default as eligible_45quotesN8JHUKbVnxczVZGRBNtQZSbvE5tr0eU94Wcm7fPnS3AMeta } from "/vercel/path1/pages/dashboards/eligible-quotes.vue?macro=true";
import { default as indexBDrXKadhx5pWKk9cU7gcTEbVmaOfcHOgEV8VKDMq0PcMeta } from "/vercel/path1/pages/admin/claims/cat-tags/index.vue?macro=true";
import { default as indexPrm6KzvKVIAtmC66RnIN3YsXA97YiokG3zRSMmPk6w8Meta } from "/vercel/path1/pages/admin/agency-management/index.vue?macro=true";
import { default as indexT7TAHUVYW7rACqtEgd5Pa9l_455KTc_456ByFi_45Jo4iDvPkMeta } from "/vercel/path1/pages/dashboards/non-renewals/index.vue?macro=true";
import { default as queriesTM3YnEavSyfyW6OX0e9jXX2RHE7PqVtWRqp93aFUO08Meta } from "/vercel/path1/pages/admin/agency-management/queries.js?macro=true";
import { default as queriesSfRCeOidumBX7TvOxZ0EK4Ooq9J4EMBqvxKnMGwI5bQMeta } from "/vercel/path1/pages/dashboards/non-renewals/queries.js?macro=true";
import { default as mutationse7QvlonHUtVuXwhI8Q_pbtaMM9ZPMub8FdI3ktMGGu4Meta } from "/vercel/path1/pages/admin/agency-management/mutations.js?macro=true";
import { default as _91stepName_93rYXyzFUf_45Y3BGVCWobZ86nutWiAjEqwtB9K_45bYVHDw8Meta } from "/vercel/path1/pages/admin/claims/cat-tags/[stepName].vue?macro=true";
import { default as indexcIJvzRq1TN3Raj1P_XoTK2euzFiHJLsUrHu9v_26f2EMeta } from "/vercel/path1/pages/admin/agency-management/[agencyID]/index.vue?macro=true";
import { default as agents_45A0LHX40HNSdg2XbKdlGJv6dHIPLXVmlrzyp8EDSQqgMeta } from "/vercel/path1/pages/admin/agency-management/[agencyID]/agents.vue?macro=true";
import { default as _91agencyID_93hYzqJvXF_Ba2aQbtEBwkpy3jDRNE431RFBMdfDXIRAgMeta } from "/vercel/path1/pages/admin/agency-management/[agencyID].vue?macro=true";
import { default as index92WvM0uuiO_45sc4tTaJtjj0JbX_45VFrbH2VDprlHLrR5IMeta } from "/vercel/path1/pages/dashboards/upcoming-renewals/index.vue?macro=true";
import { default as _91stepName_93Tt7kvqQXVuEQqAGedUGp6M2EuSF5xRP_kNnPxT2qUv0Meta } from "/vercel/path1/pages/admin/claims/cat-tags/[tagUuid]/[stepName].vue?macro=true";
export default [
  {
    name: "ping",
    path: "/ping",
    component: () => import("/vercel/path1/pages/ping.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexqYfu2AWB8IxcjYRpy3wfXaf7X1a5C3aGnOp5CZNI1c4Meta || {},
    component: () => import("/vercel/path1/pages/index.vue")
  },
  {
    name: "authenticate",
    path: "/authenticate",
    component: () => import("/vercel/path1/pages/authenticate.vue")
  },
  {
    name: "unauthenticate",
    path: "/unauthenticate",
    component: () => import("/vercel/path1/pages/unauthenticate.vue")
  },
  {
    name: _91policyNumber_93DT4ejZcwRlSy3mdO29HORR6A7849mfQyxjZ0H8s8xwsMeta?.name,
    path: "/auto/:policyNumber()",
    meta: _91policyNumber_93DT4ejZcwRlSy3mdO29HORR6A7849mfQyxjZ0H8s8xwsMeta || {},
    component: () => import("/vercel/path1/pages/auto/[policyNumber].vue"),
    children: [
  {
    name: indexOacNblXxLXD43UYcSSyd7TytpBC7dbi_7DDTxTRVmoIMeta?.name,
    path: "",
    meta: indexOacNblXxLXD43UYcSSyd7TytpBC7dbi_7DDTxTRVmoIMeta || {},
    component: () => import("/vercel/path1/pages/auto/[policyNumber]/index.vue"),
    children: [
  {
    name: "auto-policyNumber-index",
    path: "",
    meta: indexR3NND4_45x_45M4z31teDYpUW6EnRqMqqxjBrv13bpwDpJIMeta || {},
    component: () => import("/vercel/path1/pages/auto/[policyNumber]/index/index.vue")
  },
  {
    name: "auto-policyNumber-index-notes",
    path: "notes",
    meta: notesmnbAsMcV2GaLKx5t12s4J6Lw3Hkl0oHmISOx_45BbQK30Meta || {},
    component: () => import("/vercel/path1/pages/auto/[policyNumber]/index/notes.vue")
  },
  {
    name: "auto-policyNumber-index-claims",
    path: "claims",
    component: () => import("/vercel/path1/pages/auto/[policyNumber]/index/claims.vue")
  },
  {
    name: "auto-policyNumber-index-policy",
    path: "policy",
    component: () => import("/vercel/path1/pages/auto/[policyNumber]/index/policy.vue")
  },
  {
    name: "auto-policyNumber-index-billing",
    path: "billing",
    component: () => import("/vercel/path1/pages/auto/[policyNumber]/index/billing.vue")
  },
  {
    name: "auto-policyNumber-index-parties",
    path: "parties",
    component: () => import("/vercel/path1/pages/auto/[policyNumber]/index/parties.vue")
  },
  {
    name: "auto-policyNumber-index-activity",
    path: "activity",
    component: () => import("/vercel/path1/pages/auto/[policyNumber]/index/activity.vue")
  },
  {
    name: "auto-policyNumber-index-documents",
    path: "documents",
    component: () => import("/vercel/path1/pages/auto/[policyNumber]/index/documents.vue")
  }
]
  },
  {
    name: "auto-policyNumber-change",
    path: "change",
    meta: changeGjdBfPGcB4HKuy7zEVagV18mZ65VAPyr9eU7pq6WeQwMeta || {},
    component: () => import("/vercel/path1/pages/auto/[policyNumber]/change.vue"),
    children: [
  {
    name: "auto-policyNumber-change-id-admin",
    path: ":id()/admin",
    component: () => import("/vercel/path1/pages/auto/[policyNumber]/change/[id]/admin.vue")
  },
  {
    name: "auto-policyNumber-change-id-billing",
    path: ":id()/billing",
    component: () => import("/vercel/path1/pages/auto/[policyNumber]/change/[id]/billing.vue")
  },
  {
    name: "auto-policyNumber-change-id-drivers",
    path: ":id()/drivers",
    meta: driversK_457o_45lB253uBI3muITXwXlvxgVOrPUkMKxU2R6_45pLX0Meta || {},
    component: () => import("/vercel/path1/pages/auto/[policyNumber]/change/[id]/drivers.vue")
  },
  {
    name: "auto-policyNumber-change-id-parties",
    path: ":id()/parties",
    component: () => import("/vercel/path1/pages/auto/[policyNumber]/change/[id]/parties.vue")
  },
  {
    name: "auto-policyNumber-change-id-coverage",
    path: ":id()/coverage",
    meta: coverageTl1ZNx_crzPICW4QohS8_45_45klkXAbalqzG9Jg5DCUarIMeta || {},
    component: () => import("/vercel/path1/pages/auto/[policyNumber]/change/[id]/coverage.vue")
  },
  {
    name: "auto-policyNumber-change-id-vehicles",
    path: ":id()/vehicles",
    component: () => import("/vercel/path1/pages/auto/[policyNumber]/change/[id]/vehicles.vue")
  },
  {
    name: "auto-policyNumber-change-id-household",
    path: ":id()/household",
    meta: householdCa5aV1NWrjLuKouzLiPkkh_D_VgFHi7wRnvKSYjXETcMeta || {},
    component: () => import("/vercel/path1/pages/auto/[policyNumber]/change/[id]/household.vue")
  },
  {
    name: "auto-policyNumber-change-id-review-and-bind",
    path: ":id()/review-and-bind",
    meta: review_45and_45bindYTLjLD4OWWQjwCiGy_xf_45U9nDmPre6DrvI_CnovUt_UMeta || {},
    component: () => import("/vercel/path1/pages/auto/[policyNumber]/change/[id]/review-and-bind.vue")
  }
]
  },
  {
    name: "auto-policyNumber-queries",
    path: "queries",
    component: () => import("/vercel/path1/pages/auto/[policyNumber]/queries.js")
  },
  {
    name: "auto-policyNumber-mutations",
    path: "mutations",
    component: () => import("/vercel/path1/pages/auto/[policyNumber]/mutations.js")
  }
]
  },
  {
    name: _91policyNumber_932Nxjd1DB7VNDPo5XI_45A2UyMPgYYauY7Yot_45QR8LxBFQMeta?.name,
    path: "/home/:policyNumber()",
    component: () => import("/vercel/path1/pages/home/[policyNumber].vue"),
    children: [
  {
    name: index_2xEf9HXpWFE5IbsVkWAyQsrjVAcPZAiNMHsJl0REj0Meta?.name,
    path: "",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/index.vue"),
    children: [
  {
    name: "home-policyNumber-index",
    path: "",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/index/index.vue")
  },
  {
    name: "home-policyNumber-index-notes",
    path: "notes",
    meta: notes6zTTGsbYfuEej_45f4Bt5lugp_uW86POkehf3L_eVVPgYMeta || {},
    component: () => import("/vercel/path1/pages/home/[policyNumber]/index/notes.vue")
  },
  {
    name: "home-policyNumber-index-claims",
    path: "claims",
    meta: claims9Od20x9ewo_sClX3WAyIY6Tuxae9UsOF_RVnde_45mL_IMeta || {},
    component: () => import("/vercel/path1/pages/home/[policyNumber]/index/claims.vue")
  },
  {
    name: "home-policyNumber-index-queries",
    path: "queries",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/index/queries.js")
  },
  {
    name: "home-policyNumber-index-billing",
    path: "billing",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/index/billing.vue")
  },
  {
    name: "home-policyNumber-index-parties",
    path: "parties",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/index/parties.vue")
  },
  {
    name: "home-policyNumber-index-activity",
    path: "activity",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/index/activity.vue")
  },
  {
    name: "home-policyNumber-index-mutations",
    path: "mutations",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/index/mutations.js")
  },
  {
    name: "home-policyNumber-index-documents",
    path: "documents",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/index/documents.vue")
  },
  {
    name: "home-policyNumber-index-policy-details",
    path: "policy-details",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/index/policy-details.vue")
  },
  {
    name: "home-policyNumber-index-renewal-comparison",
    path: "renewal-comparison",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/index/renewal-comparison.vue")
  }
]
  },
  {
    name: "home-policyNumber-queries",
    path: "queries",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/queries.js")
  },
  {
    name: "home-policyNumber-file-claim",
    path: "file-claim",
    meta: file_45claimvu5uaVFAtqt8sDABBpEELU_4548gdoXLREhtXhMWZGJU4Meta || {},
    component: () => import("/vercel/path1/pages/home/[policyNumber]/file-claim.vue"),
    children: [
  {
    name: "home-policyNumber-file-claim-damage",
    path: "damage",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/file-claim/damage.vue")
  },
  {
    name: "home-policyNumber-file-claim-review",
    path: "review",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/file-claim/review.vue")
  },
  {
    name: "home-policyNumber-file-claim-contacts",
    path: "contacts",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/file-claim/contacts.vue")
  },
  {
    name: "home-policyNumber-file-claim-createClaimPayload",
    path: "createClaimPayload",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/file-claim/createClaimPayload.js")
  }
]
  },
  {
    name: "home-policyNumber-termID-transactionID-change",
    path: ":termID()/:transactionID()/change",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/change.vue"),
    children: [
  {
    name: "home-policyNumber-termID-transactionID-change-admin",
    path: "admin",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/change/admin.vue")
  },
  {
    name: "home-policyNumber-termID-transactionID-change-queries",
    path: "queries",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/change/queries.js")
  },
  {
    name: "home-policyNumber-termID-transactionID-change-review",
    path: "review",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/change/review.vue")
  },
  {
    name: "home-policyNumber-termID-transactionID-change-billing",
    path: "billing",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/change/billing.vue")
  },
  {
    name: "home-policyNumber-termID-transactionID-change-parties",
    path: "parties",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/change/parties.vue")
  },
  {
    name: "home-policyNumber-termID-transactionID-change-coverage",
    path: "coverage",
    meta: coverageHyf7Yy15IaORoyNRN3yJodZEd7lXuKD3LMpP_VtKEsQMeta || {},
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/change/coverage.vue")
  },
  {
    name: "home-policyNumber-termID-transactionID-change-mutations",
    path: "mutations",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/change/mutations.js")
  },
  {
    name: "home-policyNumber-termID-transactionID-change-property",
    path: "property",
    meta: propertyCg1PA8Xe_45_NH7Simqytbln_45B70rjvm68_45PpM_45FFg__QMeta || {},
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/change/property.vue")
  },
  {
    name: "home-policyNumber-termID-transactionID-change-partiesStateFactory",
    path: "partiesStateFactory",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/change/partiesStateFactory.js")
  }
]
  },
  {
    name: "home-policyNumber-termID-transactionID-queries",
    path: ":termID()/:transactionID()/queries",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/queries.js")
  },
  {
    name: "home-policyNumber-termID-transactionID-mutations",
    path: ":termID()/:transactionID()/mutations",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/mutations.js")
  },
  {
    name: "home-policyNumber-termID-transactionID-reschedule",
    path: ":termID()/:transactionID()/reschedule",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/reschedule.vue"),
    children: [
  {
    name: "home-policyNumber-termID-transactionID-reschedule-queries",
    path: "queries",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/reschedule/queries.js")
  },
  {
    name: "home-policyNumber-termID-transactionID-reschedule-review",
    path: "review",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/reschedule/review.vue")
  },
  {
    name: "home-policyNumber-termID-transactionID-reschedule-mutations",
    path: "mutations",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/reschedule/mutations.js")
  },
  {
    name: "home-policyNumber-termID-transactionID-reschedule-effectiveDate",
    path: "effectiveDate",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/reschedule/effectiveDate.vue")
  }
]
  },
  {
    name: cancellation211n01_45yrFXxoEkGRKCZQbHOQCYXNHLIC6KNHm8TsPQMeta?.name,
    path: ":termID()/:transactionID()/cancellation",
    meta: cancellation211n01_45yrFXxoEkGRKCZQbHOQCYXNHLIC6KNHm8TsPQMeta || {},
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/cancellation.vue"),
    children: [
  {
    name: "home-policyNumber-termID-transactionID-cancellation",
    path: "",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/cancellation/index.vue")
  },
  {
    name: "home-policyNumber-termID-transactionID-cancellation-review",
    path: "review",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/cancellation/review.vue")
  },
  {
    name: "home-policyNumber-termID-transactionID-cancellation-cancellationContext",
    path: "cancellationContext",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/cancellation/cancellationContext.js")
  }
]
  },
  {
    name: "home-policyNumber-termID-transactionID-agentOfRecord",
    path: ":termID()/:transactionID()/agentOfRecord",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/agentOfRecord.vue"),
    children: [
  {
    name: "home-policyNumber-termID-transactionID-agentOfRecord-queries",
    path: "queries",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/agentOfRecord/queries.js")
  },
  {
    name: "home-policyNumber-termID-transactionID-agentOfRecord-review",
    path: "review",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/agentOfRecord/review.vue")
  },
  {
    name: "home-policyNumber-termID-transactionID-agentOfRecord-update",
    path: "update",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/agentOfRecord/update.vue")
  },
  {
    name: "home-policyNumber-termID-transactionID-agentOfRecord-mutations",
    path: "mutations",
    component: () => import("/vercel/path1/pages/home/[policyNumber]/[termID]/[transactionID]/agentOfRecord/mutations.js")
  }
]
  }
]
  },
  {
    name: "account-search",
    path: "/account/search",
    meta: indexTXD2rJTDeIDp9A6H1WuJi5cRwAx9pkI_45yRJtYT5aTB0Meta || {},
    component: () => import("/vercel/path1/pages/account/search/index.vue")
  },
  {
    name: indexElOgL68gsBNUUTPeRNoRdudcYO4400M0E3SuSRFmLqAMeta?.name,
    path: "/admin/settings",
    component: () => import("/vercel/path1/pages/admin/settings/index.vue"),
    children: [
  {
    name: teamwIbTOC1is2t5bsi_ZumQKGs2TvA5XQ5abneOWl9vJD8Meta?.name,
    path: "team",
    component: () => import("/vercel/path1/pages/admin/settings/index/team.vue"),
    children: [
  {
    name: "admin-settings-index-team",
    path: "",
    component: () => import("/vercel/path1/pages/admin/settings/index/team/index.vue")
  },
  {
    name: "admin-settings-index-team-userID",
    path: ":userID()",
    component: () => import("/vercel/path1/pages/admin/settings/index/team/[userID].vue")
  }
]
  },
  {
    name: "admin-settings-index",
    path: "",
    component: () => import("/vercel/path1/pages/admin/settings/index/index.vue")
  },
  {
    name: "admin-settings-index-queries",
    path: "queries",
    component: () => import("/vercel/path1/pages/admin/settings/index/queries.js")
  },
  {
    name: "admin-settings-index-mutations",
    path: "mutations",
    component: () => import("/vercel/path1/pages/admin/settings/index/mutations.js")
  },
  {
    name: "admin-settings-index-commissions",
    path: "commissions",
    meta: commissionsgqIK5G42ZnmrMPR_457a4iQXwficRAGOuA3VsWBRPcrPkMeta || {},
    component: () => import("/vercel/path1/pages/admin/settings/index/commissions.vue")
  },
  {
    name: "admin-settings-index-integrations",
    path: "integrations",
    component: () => import("/vercel/path1/pages/admin/settings/index/integrations.vue")
  },
  {
    name: "admin-settings-index-agency-details",
    path: "agency-details",
    component: () => import("/vercel/path1/pages/admin/settings/index/agency-details.vue")
  }
]
  },
  {
    name: "account-search-queries",
    path: "/account/search/queries",
    component: () => import("/vercel/path1/pages/account/search/queries.js")
  },
  {
    name: "dashboards-search",
    path: "/dashboards/search",
    meta: indexRlt32t_454LZ38NJrvLupCH_45k4WNjz_456ZFXfwIFogbQ_wMeta || {},
    component: () => import("/vercel/path1/pages/dashboards/search/index.vue")
  },
  {
    name: "dashboards-search-queries",
    path: "/dashboards/search/queries",
    component: () => import("/vercel/path1/pages/dashboards/search/queries.js")
  },
  {
    name: "account-accountID",
    path: "/account/:accountID()",
    meta: indexHNvyT6WglBoNhKekP_KUVMpo9eaA8t_45sFe9KogOJBuYMeta || {},
    component: () => import("/vercel/path1/pages/account/[accountID]/index.vue")
  },
  {
    name: "admin-policy-search",
    path: "/admin/policy-search",
    meta: indexmhHxUnyynFMJP6RGA_45ozciGRdu_45WdL8G5BkfYDzhmycMeta || {},
    component: () => import("/vercel/path1/pages/admin/policy-search/index.vue")
  },
  {
    name: "account-accountID-queries",
    path: "/account/:accountID()/queries",
    component: () => import("/vercel/path1/pages/account/[accountID]/queries.js")
  },
  {
    name: "dashboards-eligible-quotes",
    path: "/dashboards/eligible-quotes",
    component: () => import("/vercel/path1/pages/dashboards/eligible-quotes.vue")
  },
  {
    name: "admin-claims-cat-tags",
    path: "/admin/claims/cat-tags",
    meta: indexBDrXKadhx5pWKk9cU7gcTEbVmaOfcHOgEV8VKDMq0PcMeta || {},
    component: () => import("/vercel/path1/pages/admin/claims/cat-tags/index.vue")
  },
  {
    name: "admin-agency-management",
    path: "/admin/agency-management",
    meta: indexPrm6KzvKVIAtmC66RnIN3YsXA97YiokG3zRSMmPk6w8Meta || {},
    component: () => import("/vercel/path1/pages/admin/agency-management/index.vue")
  },
  {
    name: "dashboards-non-renewals",
    path: "/dashboards/non-renewals",
    meta: indexT7TAHUVYW7rACqtEgd5Pa9l_455KTc_456ByFi_45Jo4iDvPkMeta || {},
    component: () => import("/vercel/path1/pages/dashboards/non-renewals/index.vue")
  },
  {
    name: "admin-agency-management-queries",
    path: "/admin/agency-management/queries",
    component: () => import("/vercel/path1/pages/admin/agency-management/queries.js")
  },
  {
    name: "dashboards-non-renewals-queries",
    path: "/dashboards/non-renewals/queries",
    component: () => import("/vercel/path1/pages/dashboards/non-renewals/queries.js")
  },
  {
    name: "admin-agency-management-mutations",
    path: "/admin/agency-management/mutations",
    component: () => import("/vercel/path1/pages/admin/agency-management/mutations.js")
  },
  {
    name: "admin-claims-cat-tags-stepName",
    path: "/admin/claims/cat-tags/:stepName()",
    meta: _91stepName_93rYXyzFUf_45Y3BGVCWobZ86nutWiAjEqwtB9K_45bYVHDw8Meta || {},
    component: () => import("/vercel/path1/pages/admin/claims/cat-tags/[stepName].vue")
  },
  {
    name: _91agencyID_93hYzqJvXF_Ba2aQbtEBwkpy3jDRNE431RFBMdfDXIRAgMeta?.name,
    path: "/admin/agency-management/:agencyID()",
    component: () => import("/vercel/path1/pages/admin/agency-management/[agencyID].vue"),
    children: [
  {
    name: "admin-agency-management-agencyID",
    path: "",
    component: () => import("/vercel/path1/pages/admin/agency-management/[agencyID]/index.vue")
  },
  {
    name: "admin-agency-management-agencyID-agents",
    path: "agents",
    component: () => import("/vercel/path1/pages/admin/agency-management/[agencyID]/agents.vue")
  }
]
  },
  {
    name: "dashboards-upcoming-renewals",
    path: "/dashboards/upcoming-renewals",
    component: () => import("/vercel/path1/pages/dashboards/upcoming-renewals/index.vue")
  },
  {
    name: "admin-claims-cat-tags-tagUuid-stepName",
    path: "/admin/claims/cat-tags/:tagUuid()/:stepName()",
    meta: _91stepName_93Tt7kvqQXVuEQqAGedUGp6M2EuSF5xRP_kNnPxT2qUv0Meta || {},
    component: () => import("/vercel/path1/pages/admin/claims/cat-tags/[tagUuid]/[stepName].vue")
  }
]